import { render } from "./ExtractNode.vue?vue&type=template&id=6125244c&scoped=true"
import script from "./ExtractNode.vue?vue&type=script&lang=js"
export * from "./ExtractNode.vue?vue&type=script&lang=js"

import "./ExtractNode.vue?vue&type=style&index=0&id=6125244c&scoped=true&lang=css"

import exportComponent from "/Users/victoriengarrigues/Documents/Moonarch-DEV/code/moonarch-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6125244c"]])

export default __exports__